export interface EnumOption {
  id: number;
  labels: Record<number, string>;
}

/**
 * Resolves a localized label from an enum options array (e.g. MARITAL_STATUS).
 * Returns '—' if value is missing or not found.
 */
export const getEnumLabel = (
  options: EnumOption[],
  value: number | string | undefined | null,
  lan: number
): string => {
  if (value === undefined || value === null || value === '') return '—';
  
  const numericValue = Number(value);
  const found = options.find((opt) => opt.id === numericValue);
  
  return found?.labels[lan] ?? found?.labels[0] ?? '—';
};